import { CAP, IGNORE } from '../../PCBHelper';
import { _getVRM, getAllCascadeComponents, getAllCascadeNets, getNets, getPMIC, getPowerSwitchPinMap } from '../helper/setupData'
import settingStore from '../helper/compSettingHelper';
import componentDoNotStuff from '../../helper/componentsHelper/compDoNotStuff';
import compTableHelper from '@/services/Cascade/helper/compTableHelper.js'
import { strDelimited } from '../../helper/split';
import pinMapStore from '@/services/Cascade/library/pinMapHelper'
import compPinMap from '../helper/compPinMap';
import { SortFn } from '../../helper/sort';
import sleep from '../../helper/sleep';
import { PARTBASED } from '../../../constants/resolution';
import auroraDBJson from '../../Designs/auroraDbData';
import { getDefaultIndex } from '../../helper/setDefaultName';
import PowerTreeMaker from '../../helper/componentsHelper/GetPath/getPowerTree_v2';
import componentSetting from '../helper/compSettingHelper';
import { getTreeComponentGnd } from '../PowerTree/v2/helper';
import { VIN, VOUT, VSENSE, PMIC_DATA_TYPE_LIST } from '../constants';
import { PMIC, SOC } from '../../../constants/componentType';

const compPinsInfo = new Map();

function getCompPins(designId, comp) {
  const key = `${designId}:${comp}`;
  if (!compPinsInfo.has(key)) {
    compPinsInfo.set(
      key,
      auroraDBJson.getComponentPins(designId, comp)
    );
  }
  return compPinsInfo.get(key);
}

function getTemplateComponents({ components, designId, componentsTableDisplay }) {
  let comps = [];
  for (let comp of components) {
    if (!comp) {
      continue;
    }
    const { name, part, pins, usage, COMP_TYPE, models, applySweep } = comp;
    const partNumber = auroraDBJson.getPartNumberByPartName(designId, part);
    if (componentsTableDisplay === PARTBASED) {
      const findIndex = comps.findIndex(item => item.part === part && item.usage === usage);
      if (findIndex > -1) {
        comps[findIndex].components.push({ name, pins, usage })
      } else {
        comps.push({
          models,
          applySweep,
          COMP_TYPE,
          part,
          partNumber,
          usage,
          applySweep,
          components: [{
            name,
            pins,
            usage
          }]
        })
      }
    } else {
      comps.push({
        models,
        applySweep,
        COMP_TYPE,
        part,
        partNumber,
        usage,
        components: [{
          name,
          pins,
          usage
        }]
      })
    }
  }
  comps = SortFn(comps, [CAP, IGNORE], 'usage');
  return comps;
}

async function updateOnePowerCapComponents({
  signOffTemplateInfo,
  templates,
  deleteRecord,
  saveLogs,
  powerNet
}) {

  const templateInfo = getGroupByTemplate(templates, signOffTemplateInfo.soc, signOffTemplateInfo.gnd);
  if (!templateInfo) {
    return { signOffTemplateInfo, newNoModelCompNames: [] };
  }
  if (deleteRecord && deleteRecord.groupKey && deleteRecord.groupKey !== templates[0].groupKey) {
    return { signOffTemplateInfo, newNoModelCompNames: [] };
  }

  let components = signOffTemplateInfo.components || [];
  const designId = signOffTemplateInfo.designId;
  let signOffTemplate = signOffTemplateInfo.signOffTemplate;
  let newNoModelCompNames = [], prevComps = [];
  const templateIndex = signOffTemplate.findIndex(item => item.groupKey === templates[0].groupKey);

  if (templateIndex > -1) {
    prevComps = signOffTemplate[templateIndex].components ? [...signOffTemplate[templateIndex].components] : [];
    signOffTemplate[templateIndex].components = [];
  }

  let { soc, powerNetName, gnd, pmicList, pmicAndNets, dataType, powerPins = [], groundPins = [], peakCurrent } = templateInfo || {};

  let _setting = await settingStore.getSetting({ designId });
  let doNotStuff = await componentDoNotStuff.getDoNotStuff(designId);
  const table = await compTableHelper.getTableData(designId);
  // const allComponents = pmicList.length ? getAllCascadeComponents({ pcbId: designId }) : [];
  pmicList = [...new Set([...pmicList])];

  // for (let pmic of pmicList) {
  //   const findPMIC = allComponents.find(item => item.name === pmic) || {};
  //   const pmicPart = findPMIC.part;

  //   //add pmic part to specialized
  //   const prevPmicParts = [..._setting.compPrefixLib.specialized,
  //   ..._setting.compPrefixLib.linearRegulator,
  //   ..._setting.compPrefixLib.linearSwitch,
  //   ..._setting.compPrefixLib.switchingRegulator
  //   ]
  //   const existPmic = prevPmicParts.includes(pmicPart);
  //   const newSpecialized = pmicPart && !existPmic ? [...new Set([..._setting.compPrefixLib.specialized, pmicPart])] : [..._setting.compPrefixLib.specialized];
  //   //update setting
  //   if (settingStore.compareSetting(designId, { ..._setting.compPrefixLib, specialized: newSpecialized })) {
  //     const newVersion = versionUpdate(_setting.version);
  //     const newSetting = {
  //       designId, componentSetting: {
  //         compPrefixLib: { ..._setting.compPrefixLib, specialized: newSpecialized },
  //         version: newVersion
  //       }
  //     }
  //     settingStore.updateSetting([newSetting]);
  //     _setting = await settingStore.getSetting({ designId });
  //   }
  // }

  /* pin: 'M12', net: 'ARM_REF_CLK', pinName: 'M12', mName: 'M12' */

  let loadSelect = [{ comp: soc }];

  const pinMapSense = await pinMapStore.getPinMapSense(designId, "pinName")


  let pinMap = await compPinMap.getPinMapData(designId);
  const pinConnection = await compPinMap.getPinConnection(designId);

  let pinMapList = []
  for (let _map of pinMap) {
    let data = [];
    if (_map.libraryId) {
      try {
        const res = await pinMapStore.getPinMapLibrary(_map, designId, "pinName")
        data = res && res.config && res.config.pinTable ? [...res.config.pinTable] : [];
      } catch (error) {
        console.error("Can not find library file");
      }
    }
    pinMapList.push({ ..._map, data })
  }

  let filterComponents = []
  let capOut = {}
  if (PMIC_DATA_TYPE_LIST.includes(dataType)) {
    const layoutComponents = getAllCascadeComponents({ pcbId: designId });
    const layoutNets = getAllCascadeNets({ pcbId: designId, info: true });
    const setting = await componentSetting.getPrefixLib(designId);
    const _pinConnection = await compPinMap.getPinConnection(designId);
    const pinConnection = await getPowerSwitchPinMap(_pinConnection);
    for (let item of pmicAndNets) {
      const { pmic, net, dataType } = item
      if (dataType === VSENSE) {
        continue
      }
      const groundNets = getTreeComponentGnd(pmic, designId, pinMap);
      const pmicPinsInfo = getCompPins(designId, pmic)
      const pmicPowerPins = pmicPinsInfo.filter(pin => pin.net === net && powerPins.includes(pin.pin));
      const powerTreeMaker = new PowerTreeMaker({
        compName: pmic,
        powerNet: net,
        groundNets,
        designId,
        setting,
        table,
        pinMap,
        pinConnection,
        doNotStuff,
        layoutComponents,
        layoutNets,
        useInput: true,
        powerTreeLevel: 8,
        connector: {},
        // fn
        getTreeComponentGnd
      })
      powerTreeMaker.generatePowerTrace();
      powerTreeMaker.generateGround();
      const path = powerTreeMaker.getShortestPath();
      const pathNets = [];
      if (path) {
        let soc = '', socNet = ''
        path.forEach((item, index) => {
          if (item.nextNet) {
            pathNets.push(item.nextNet)
          }
          if (index === path.length - 1) {
            if (item.type === 'Load') {
              soc = item.name
              socNet = item.prevNet
            }
          }
        })
        let pmicGroupKey = null
        const groupKeys = [...new Set(signOffTemplate.filter(item => item.powerNetName === net).map(item => item.groupKey))];
        if (groupKeys.length) {
          pmicGroupKey = groupKeys[0];
        }
        if (soc) {
          const groupKey = pmicGroupKey || `${powerNetName}::${pmic}::${gnd || signOffTemplateInfo.gnd}`
          const findTemplateIndex = signOffTemplate.findIndex(item => item.powerNetName === socNet && item.refdes === soc && item.compType === SOC && item.groupKey === groupKey)
          if (findTemplateIndex < 0) {
            const index = getDefaultIndex(signOffTemplate.length, signOffTemplate.map(item => item.index));
            const template = {
              index,
              powerNetName: socNet || "",
              gndNetName: gnd || "",
              refdes: soc || "",
              compType: SOC,
              resultExists: false,
              impedance: [],
              powerPins: ["ALL Power Pins"],
              groundPins: ["ALL Ground Pins"],
              effectivePowerPins: [],
              effectiveGroundPins: [],
              loopDcrSpec: {},
              groupKey,
              dataType,
              peakCurrent
            }
            signOffTemplate.push({ ...template });
          }
        }
      }
      const _pathNets = [...new Set(pathNets)]
      const pathComponents = auroraDBJson.getComponentsByNets(designId, _pathNets);
      const _pathComponents = pathComponents.map(comp => {
        const { name, type, pins, value, partName, partNumber } = comp;
        let component = {
          name,
          COMP_TYPE: type,
          usage: type,
          pins: [...pins.values()],
          value,
          part: partName,
          partNumber: partNumber || undefined,
          isMultiNets: false,
          model: type === CAP ? { id: "", name: "" } : undefined
        }
        component.pins = component.pins.filter(pin => [..._pathNets, gnd].includes(pin.net));
        if (type === CAP) {
          if (!component.pins.some(pin => gnd === pin.net)) {
            return null;
          }
          if ([...new Set(component.pins.map(pin => pin.net))].length > 2) {
            component.isMultiNets = true;
          }
          component.value = "";
          return { ...component, usage: doNotStuff.includes(name) ? IGNORE : CAP }
        }
      }).filter(comp => !!comp)

      filterComponents.push(..._pathComponents)

      if (dataType === VOUT) {
        let closestComp = null, minDist = Infinity;
        for (const comp of _pathComponents) {
          const { name } = comp
          const compPowerPins = getCompPins(designId, name).filter(pin => pin.net !== gnd);
          for (const compPin of compPowerPins) {
            for (const pmicPin of pmicPowerPins) {
              const dx = compPin.x - pmicPin.x;
              const dy = compPin.y - pmicPin.y;
              const dist = Math.sqrt(dx * dx + dy * dy);
              if (dist < minDist) {
                minDist = dist;
                closestComp = name;
              }
            }
          }
        }
        if (closestComp) {
          const allPins = getCompPins(designId, closestComp);
          capOut = {
            name: closestComp,
            powerPins: allPins.filter(pin => pin.net === powerNet).map(pin => pin.pin),
            groundPins: allPins.filter(pin => pin.net === gnd).map(pin => pin.pin)
          };
        }
      }
    }
  } else {
    const specify = pmicAndNets.map(item => ({ name: item.pmic, nets: [item.net] }))
    const netsInfo = getNets(designId);
    const { loadComponents } = netsInfo;
    const pmicComps = loadComponents.length ? loadComponents.map(item => item.name) : []
    let VRMInfo = _getVRM({
      designId,
      GroundNets: [gnd],
      PowerNets: [powerNetName],
      ExtendNets: [],
      COMP_PREFIX_LIB: _setting.compPrefixLib,
      loadSelect,
      connectInductance: false,
      findExtend: true,
      isAC: true,
      PMIC: getPMIC(_setting.compPrefixLib),
      powerSwitch: _setting.compPrefixLib.powerSwitch,
      doNotStuff,
      table,
      pinMapSense,
      pmicAndNets,
      pinMap: pinMapList,
      specify,
      pinConnection,
      pmicComps: !specify.length ? pmicComps : [],
      deleteRecord,
      fuzzyMatch: true,
      includeChip: [VIN].includes(dataType)
    })
    if (VRMInfo && VRMInfo.DEBUG_MONITOR && VRMInfo.DEBUG_MONITOR.length) {
      VRMInfo.DEBUG_MONITOR.forEach(monitor => {
        const netList = monitor.filter(item => item.type === 'net');
        const compList = monitor.filter(item => item.type === 'comp');
        const pmicOutNet = netList.length > 0 ? netList[netList.length - 1].name : "";
        const pmic = compList.length > 0 ? compList[compList.length - 1].name : ""
        if (saveLogs && powerNet && pmic) {
          saveLogs([{ type: 'normal', text: `[${powerNet}] Find ${pmic} as PMIC.` }]);
        }
        let pmicGroupKey = null
        const groupKeys = [...new Set(signOffTemplate.filter(item => item.powerNetName === powerNetName).map(item => item.groupKey))];
        if (groupKeys.length) {
          pmicGroupKey = groupKeys[0];
        }
        const groupKey = pmicGroupKey || `${powerNetName}::${soc || signOffTemplateInfo.soc}::${gnd || signOffTemplateInfo.gnd}`
        const findTemplateIndex = signOffTemplate.findIndex(item => item.powerNetName === pmicOutNet && item.refdes === pmic && item.compType === PMIC && item.groupKey === groupKey)
        if (findTemplateIndex < 0) {
          const index = getDefaultIndex(signOffTemplate.length, signOffTemplate.map(item => item.index));
          let filterPowerPins = ["ALL Power Pins"], filterGroundPins = ["ALL Ground Pins"]
          if (pmic === soc) {
            const pmicPins = getCompPins(designId, pmic)
            const pmicPowerPins = pmicPins.filter(it => it.net === pmicOutNet).map(item => item.pin);
            const pmicGroundPins = pmicPins.filter(it => it.net === gnd).map(item => item.pin);
            filterPowerPins = pmicPowerPins.filter(pin => !powerPins.includes(pin))
            filterGroundPins = pmicGroundPins.filter(pin => !groundPins.includes(pin))
          }
          const template = {
            index,
            powerNetName: pmicOutNet || "",
            gndNetName: gnd || "",
            refdes: pmic || "",
            compType: "PMIC",
            resultExists: false,
            impedance: [],
            powerPins: filterPowerPins,
            groundPins: filterGroundPins,
            effectivePowerPins: [],
            effectiveGroundPins: [],
            loopDcrSpec: {},
            groupKey
          }
          signOffTemplate.push({ ...template });
        }
      })
    } else {
      if (saveLogs && powerNet) {
        saveLogs([{ type: 'normal', text: `[${powerNet}] Find No Component as PMIC.` }]);
      }
    }
    //filter vrm by pmic list(user selected pmic components)
    const filterVRMPath = VRMInfo.DEBUG_MONITOR.filter(item => pmicList.includes(item[item.length - 1].name))
    // if (!pmicList.length || filterVRMPath.length) {

    const allPowerNets = filterVRMPath.filter(item => item.type === "net").map(item => item.name);
    //filter components
    filterComponents = !pmicList.length ? VRMInfo.Components : VRMInfo.Components.filter(item => {
      item.pins = item.pins.filter(it => [...allPowerNets, gnd].includes(it.net));
      if (item.pins.length) {
        return item;
      }
      return false;
    });
  }

  for (let comp of filterComponents) {
    if (comp.COMP_TYPE !== "Cap") {
      continue;
    }
    const index = components.findIndex(it => it.name === comp.name);
    if (index < 0) {
      const samePartComp = components.find(it => it.part === comp.part);
      if (samePartComp && samePartComp.models && samePartComp.models.length) {
        comp.models = JSON.parse(JSON.stringify(samePartComp.models));
      } else {
        newNoModelCompNames.push(comp.name);
      }
      components.push(comp);
    } else {
      const pinList = components[index].pins.map(item => item.pin);
      const _pins = comp.pins.filter(item => !pinList.includes(item.pin));
      components[index].pins.push(..._pins);
      components[index].usage = comp.usage;
      components[index].part = comp.part
      components[index].partNumber = comp.partNumber
    }
    if (templateIndex > -1) {
      signOffTemplate[templateIndex].components.push(...comp.pins.map(it => `${comp.name}::${it.pin}`))
    }
  }
  if (templateIndex > -1) {
    signOffTemplate[templateIndex].capOut = capOut
  }
  /*}  else {
    //todo if user selected pmic not find, show error message and delete prev components
      components = deleteComponents(prevComps, signOffTemplate, components);
    } */

  signOffTemplateInfo.components = components;
  signOffTemplateInfo.signOffTemplate = signOffTemplate.map((item, index) => { return { ...item, index: String(index) } });
  return { signOffTemplateInfo, newNoModelCompNames };
}

function getGroupByTemplate(templateList, comp, gnd) {
  let groupObj = { extendNets: [], pmicList: [], pmicAndNets: [] };
  const dataType = templateList && templateList.length ? templateList[0].dataType : ''
  if (PMIC_DATA_TYPE_LIST.includes(dataType)) {
    const pmicFind = templateList.find(item => item.compType === PMIC) || {};
    const powerPins = [...new Set(templateList.filter(item => item.compType === PMIC).map(item => item.effectivePowerPins || []).flat())]
    groupObj.powerNetName = pmicFind.powerNetName;
    groupObj.pmic = pmicFind.refdes || "";
    groupObj.gnd = pmicFind.gndNetName || gnd;
    groupObj.dataType = pmicFind.dataType || dataType
    groupObj.powerPins = powerPins || []
    groupObj.peakCurrent = pmicFind.peakCurrent || {}
  } else {
    const socFind = templateList.find(item => item.compType === SOC) || {};
    const powerPins = [...new Set(templateList.filter(item => item.compType === SOC).map(item => item.effectivePowerPins || []).flat())]
    const groundPins = [...new Set(templateList.filter(item => item.compType === SOC).map(item => item.effectiveGroundPins || []).flat())]
    groupObj.powerNetName = socFind.powerNetName;
    groupObj.soc = socFind.refdes || comp;
    groupObj.gnd = socFind.gndNetName || gnd;
    groupObj.dataType = socFind.dataType || dataType
    groupObj.powerPins = powerPins || []
    groupObj.groundPins = groundPins || []
  }

  if (!groupObj.powerNetName || (!groupObj.pmic && !groupObj.soc) || !groupObj.gnd) {
    return null;
  }

  const pmicList = templateList.filter(item => item.compType === PMIC);

  for (let item of pmicList) {
    groupObj.extendNets = [...new Set([...groupObj.extendNets, item.powerNetName])];
    groupObj.pmicList.push(item.refdes);
    groupObj.pmicAndNets.push({ net: item.powerNetName, pmic: item.refdes, dataType: item.dataType });
  }
  return groupObj;
}

async function updateTemplateItemCompsByVersion(signOffTemplateInfo, newTemplates, saveLogs, deleteRecord, pmicBased) {
  const _newTemplates = newTemplates ? newTemplates : signOffTemplateInfo.signOffTemplate;

  const groupList = [...new Set(_newTemplates.map(item => item.groupKey))];
  for (let group of groupList) {
    const [powerNet, , , isPmic] = strDelimited(group, "::");
    if (isPmic) {
      continue;
    }
    if (saveLogs && powerNet) {
      saveLogs([{ type: 'normal', text: `[${powerNet}] Searching Cap of ${powerNet}.` }]);
      await sleep(100);
    }
    const templates = signOffTemplateInfo.signOffTemplate.filter(item => item.groupKey === group);
    const data = await updateOnePowerCapComponents({
      signOffTemplateInfo: signOffTemplateInfo,
      templates,
      deleteRecord,
      saveLogs,
      powerNet
    })
    signOffTemplateInfo = data.signOffTemplateInfo;
  }
  const _components = []
  signOffTemplateInfo.signOffTemplate.forEach(item => {
    (item.components || []).forEach(comp => {
      const [compName, pin] = strDelimited(comp, "::");
      if (compName) {
        _components.push(compName)
      }
    })
  })
  signOffTemplateInfo.components = (signOffTemplateInfo.components || []).filter(item => _components.includes(item.name))
  return signOffTemplateInfo;
}

function deleteComponents(delTemplateComps, templates, components) {
  if (!delTemplateComps) {
    return components;
  }
  const existTemplates = templates.filter(item => item.components && item.components.length);
  let existComponents = [];
  for (let item of existTemplates) {
    existComponents.push(...item.components);
  }
  existComponents = [...new Set(existComponents)];
  const _delTemplateComps = delTemplateComps.filter(item => !existComponents.includes(item));

  components.forEach(item => {
    item.pins = item.pins.filter(it => !_delTemplateComps.includes(`${item.name}::${it.pin}`));
  });
  components = components.filter(item => !!item.pins.length);
  return components;
}

export {
  getTemplateComponents,
  updateOnePowerCapComponents,
  updateTemplateItemCompsByVersion,
  deleteComponents,
  getGroupByTemplate
}